import React from 'react';
//import {Modal as BaseModal, Button} from 'react-bootstrap';
import { default as BaseModal } from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

const Modal = ({
  show,
  close,
  hideClose,
  title,
  onEnter,
  onExit,
  children,
  bsStyle,
  containerStyle,
  ...props
}) => (
  <BaseModal
    show={show}
    onHide={close}
    onEntered={onEnter}
    onExited={onExit}
    restoreFocus={true}
    {...props}
  >
    {title ? (
      <BaseModal.Header closeButton>
        <BaseModal.Title> {title} </BaseModal.Title>
      </BaseModal.Header>
    ) : (
      ''
    )}
    <BaseModal.Body style={bsStyle}>
      <div className="container-fluid" style={containerStyle}>
        {children}
      </div>
    </BaseModal.Body>
    {close && !hideClose ? (
      <BaseModal.Footer>
        <Button onClick={close}>Close</Button>
      </BaseModal.Footer>
    ) : (
      ''
    )}
  </BaseModal>
);

export default Modal;
